/**
 * Constants and configuration values.
 */
import { Phone, Calendar, FileText, Award } from "lucide-react";

// Logo URL
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_adriatic-sales/artifacts/tijtu9v2_image.png";

// Activity Types
export const ACTIVITY_TYPES = [
  { value: "POZIV", label: "Poziv", description: "Telefonski razgovor s klijentom", icon: Phone, color: "blue" },
  { value: "DOGOVOREN_SASTANAK", label: "Dogovoren sastanak", description: "Zakazan sastanak s klijentom", icon: Calendar, color: "green" },
  { value: "PONUDA_POSLANA", label: "Ponuda", description: "Poslana ponuda klijentu", icon: FileText, color: "amber" },
  { value: "AKVIZICIJA", label: "Akvizicija", description: "Uspješno zaključen posao", icon: Award, color: "rose" },
];

export const getActivityTypeInfo = (type) => ACTIVITY_TYPES.find(t => t.value === type) || ACTIVITY_TYPES[0];

// Activity Type Labels
export const ACTIVITY_TYPE_LABELS = {
  POZIV: "Poziv",
  DOGOVOREN_SASTANAK: "Dogovoren sastanak",
  PONUDA_POSLANA: "Ponuda",
  AKVIZICIJA: "Akvizicija"
};

// Call Outcome Labels
export const CALL_OUTCOME_LABELS = {
  NO_ANSWER: "Nije se javio",
  CALL_BACK: "Nazvati ponovo",
  MEETING_SCHEDULED: "Dogovoren sastanak",
  NOT_INTERESTED: "Nije zainteresiran",
  DO_NOT_CONTACT: "Ne kontaktirati"
};

// Meeting Outcome Labels
export const MEETING_OUTCOME_LABELS = {
  HELD: "Održan",
  NO_SHOW: "Nije se pojavio",
  RESCHEDULED: "Odgođen",
  LOST: "Izgubljen"
};

// Next Step Labels
export const NEXT_STEP_LABELS = {
  FOLLOW_UP_CALL: "Follow-up poziv",
  REQUEST_OFFER_BACKOFFICE: "Zatražiti ponudu od back-officea",
  NEW_MEETING: "Novi sastanak"
};
